export const WA_INTERACTIONS_TABLE = 'waInteractionsTable';
export const ESCALATIONS_TABLE = 'escalationsTable';

export const INTERACTION_ID_QUERY = 'interactionId';

export const NESTED_BLANK_DISPOSITION_QUERY = 'interactionId*blankDisposition';
